module.exports = __webpack_public_path__ + "img/portfolio_1.afe99aa0.png";